import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InsuranceProduct } from "../../products/objects/insurance-product";
import { CrudModeOptions, OrganisationInsuranceState } from "../objects/organisationsInsuranceState";
import { Contract } from "../../sinister/objects/contract";

const initialState: OrganisationInsuranceState = {
    selected_product: null,
    product_mode: null,
    product_search: null,
    contract_search: null,
    selected_all_contract: null,
    selected_defect: null,
    price_index: 0,
    all_contract_list: [],
    defects_list: [],
    product_list: []
};

export const organisationInsurance = createSlice({
    name: 'organisationInsurance',
    initialState,
    reducers: {
        setSelectedProduct: (state: OrganisationInsuranceState, action: PayloadAction<InsuranceProduct | null>): OrganisationInsuranceState => ({
            ...state, selected_product: action.payload
        }),
        setProductMode: (state: OrganisationInsuranceState, action: PayloadAction<CrudModeOptions>): OrganisationInsuranceState => ({
            ...state, product_mode: action.payload
        }),
        setProductSearch: (state: OrganisationInsuranceState, action: PayloadAction<string | null>): OrganisationInsuranceState => ({
            ...state, product_search: action.payload
        }),
        setContractSearch: (state: OrganisationInsuranceState, action: PayloadAction<string | null>): OrganisationInsuranceState => ({
            ...state, contract_search: action.payload
        }),
        setPriceIndex: (state: OrganisationInsuranceState, action: PayloadAction<number>): OrganisationInsuranceState => ({
            ...state, price_index: action.payload
        }),
        setSelectedAllContract: (state: OrganisationInsuranceState, action: PayloadAction<Contract | null>): OrganisationInsuranceState => ({
            ...state, selected_all_contract: action.payload
        }),
        setSelectedDefect: (state: OrganisationInsuranceState, action: PayloadAction<Contract | null>): OrganisationInsuranceState => ({
            ...state, selected_defect: action.payload
        }),
        setAllContractList: (state: OrganisationInsuranceState, action: PayloadAction<Contract[]>): OrganisationInsuranceState => ({
            ...state, all_contract_list: action.payload
        }),
        setDefectsList: (state: OrganisationInsuranceState, action: PayloadAction<Contract[]>): OrganisationInsuranceState => ({
            ...state, defects: action.payload
        }),
        setInsuranceProductList: (state: OrganisationInsuranceState, action: PayloadAction<InsuranceProduct[]>): OrganisationInsuranceState => ({
            ...state, product_list: action.payload
        }),
    }
});

export const {
    setSelectedProduct,
    setProductMode,
    setProductSearch,
    setContractSearch,
    setPriceIndex,
    setSelectedAllContract,
    setAllContractList,
    setDefectsList,
    setSelectedDefect,
    setInsuranceProductList
} = organisationInsurance.actions;